import { render } from "./DivWrapperSubsection.vue?vue&type=template&id=12761db2&scoped=true"
import script from "./DivWrapperSubsection.vue?vue&type=script&lang=js"
export * from "./DivWrapperSubsection.vue?vue&type=script&lang=js"

import "./DivWrapperSubsection.vue?vue&type=style&index=0&id=12761db2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12761db2"]])

export default __exports__